import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { CommonServices } from 'src/app/Services/common.service';
import { LoaderService } from 'src/app/Services/loader.service';

@Component({
  selector: 'app-roster',
  templateUrl: './roster-new.component.html',
  styleUrls: ['./roster-new.component.css']
})
export class RosterNewComponent implements OnInit {
  public isExcelUploaded: boolean = false;
  public isVehicleStatusChanged: boolean = false;
  public userID: string = '';
  public orgID: string = '';
  public vendorID: string = '';
  public branchInformation: any = {};
  public selectedBranch: any = [];
  public vehicleListArr: any = [];
  public checkInForm: FormGroup;
  public checkOutForm: FormGroup;
  public escortCheckInForm: FormGroup;
  public escortCheckOutForm: FormGroup;
  public updatedValues: any = [];
  public checkInFormSubmitted: boolean = false;
  public checkOutFormSubmitted: boolean = false;
  public activeTab: string = 'Grouping';
  public checkInVehicles: [];
  public checkOutVehicles: [];
  public currentDate: string = '';

  public selVehCapacity: number = 0;
  public selVehType: string = '';

  public dateFilterForm: FormGroup;

  public filterDate: number;
  public minDate: string;
  public minUploadDate: string;
  public vehiclesCheckedList: any = [];
  public disableUpload: boolean = false;
  public userRestrictionData: any = {};
  public headers: any = [];
  public subModuleHeaders: any = [];
  public loadNavTabs: boolean = false;
  public clickedBranch: string = '';
  public showFilterForm: boolean = false;
  public branchChoosen: any = [];
  public availBranchIDs: any = [];
  maxDate: string;
  public todayDate: any = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  public selBranchID: any = '';
  public setTodayDate: any = new Date();
  public dateLoader: boolean = true;
  public disableAllInputs: boolean = false;
  alreadyUpload: any = [] ;
  constructor(
    public storage: StorageService,
    public api: ApiService,
    public swal: SweetAlert,
    private excel: ExcelExportService,
    private com: CommonServices,
    private loader: LoaderService
  ) {
    this.minUploadDate = this.formatDate(new Date());
    let today = new Date();
    this.minDate = this.formatDate(new Date(new Date().setDate(today.getDate() - 30)));
    this.maxDate = this.formatDate(today);
    this.orgID = this.storage.get('userInfo').orgID;
    this.userID = this.storage.get('userInfo')['userID'];
    if (this.storage.get('userInfo').branch && this.storage.get('userInfo').branch.length > 0) {
      this.selectedBranch = this.storage.get('userInfo').branch;
    }
  }
  ngOnInit(): void {
    console.log("Enterroster");
    this.getBranchList();
    let now = new Date();
    this.currentDate = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
    // this.getUserDetails();
    this.uploadFormLoad();
    //Escort 
    // this.getEscortList();
    this.checkInFormLoad();
    this.checkOutFormLoad();
    setTimeout(() => {
      this.loadContents();
    }, 1000)
  }
  loadContents() {
    let user = this.storage.get('userInfo');
    if (user && user['fieldMap']) {
      this.userRestrictionData = user['fieldMap'];
    }
    if (this.userRestrictionData['Route / Rostering'].menu1['Roster'].menu2) {
      let keys = Object.keys(this.userRestrictionData['Route / Rostering'].menu1['Roster'].menu2);
      for (let i = 0; i < keys.length; i++) {
        if (this.userRestrictionData['Route / Rostering'].menu1['Roster'].menu2[keys[i]].checked || this.userRestrictionData['Route / Rostering'].menu1['Roster'].menu2[keys[i]].indeterminate) {
          this.headers.push(keys[i]);
        }
      }
    }
    this.loadNavTabs = true;
    //Escort 
    this.escortCheckInFormLoad();
    this.escortCheckOutFormLoad();
    if (this.headers.length > 0) {

      let checkInIndex = this.headers.findIndex(e => e == 'Vehicle Check In');
      if (checkInIndex != -1) this.headers.splice(checkInIndex, 1);

      let checkOutIndex = this.headers.findIndex(e => e == 'Vehicle Check Out');
      if (checkOutIndex != -1) this.headers.splice(checkOutIndex, 1);

      if (this.headers.length > 0) {
        this.findActiveTab(this.headers[0]);
      } else {
        this.headers.push('Grouping');
        this.findActiveTab('Grouping');
      }
    }
  }
  dateFilterFormLoad() {
    let branch = Object.keys(this.branchInformation);
    this.availBranchIDs = branch;
    this.branchChoosen = [branch[0]];
    this.dateFilterForm = new FormGroup({
      filterDate: new FormControl(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'), [Validators.required]),
      overAllBranch: new FormControl(branch[0], [Validators.required]),
    });
  }
  fieldChange(e, field) {
    if (field == 'filterDate') {
      let value = new Date(e).getTime();
      this.filterDate = value;
    } else if (field == 'overAllBranch') {
      this.branchChoosen = [e];
    }
  }
  getBranchList() {
    let data = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(data).then((res: any) => {
      if (res && res.status == 'success' && res.data && res.data.length > 0) {
        if (this.storage.get('userInfo').userType && this.storage.get('userInfo').userType != 'admin') {
          for (let i = 0; i < res.data.length; i++) {
            for (let j = 0; j < this.selectedBranch.length; j++) {
              if (res.data[i]['branchID'] == this.selectedBranch[j]) {
                this.branchInformation[res.data[i]['branchID']] = res.data[i]['branchName'];
              }
            }
          }
        } else {
          for (let i = 0; i < res.data.length; i++) {
            this.branchInformation[res.data[i]['branchID']] = res.data[i]['branchName'];
          }
          this.selectedBranch = Object.keys(this.branchInformation);
        }
      } else {
        this.branchInformation = {};
      }
      this.showFilterForm = true;
      this.dateFilterFormLoad();
      this.vehicleCheckInOutList();
    }).catch((err) => {
      console.log(err);
    });
  }
  getVehicleList() {
    // Get Vehicle List API
    const obj = {
      "branch": this.branchChoosen
    };
    this.api.transportManagerOverallVehList(obj).then((res: any) => {
      this.vehicleListArr = [];
      if (res && res.status == 'success') {
        if (res && res['data'] && res['data'].length > 0) {
          let data = res['data'];
          if (this.checkInVehicles && this.checkInVehicles.length > 0) {
            this.vehicleListArr = data.filter(({ vehRegNo: id1 }) => !this.checkInVehicles.some(({ vehRegNo: id2 }) => id2 === id1));
          } else {
            this.vehicleListArr = data;
          }
        } else {
          this.vehicleListArr = [];
        }
      } else {
        this.vehicleListArr = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  findActiveTab(tab) {
    if (this.activeTab != tab) {
      this.activeTab = tab;
      // this.dateFilterForm.patchValue({
      //   filterDate:this.com.timestampToDate(new Date().getTime(),'YMD','-')
      // })
    }
  }
  checkInFormLoad() {
    this.checkInForm = new FormGroup({
      vehRegNo: new FormControl('', [Validators.required]),
      checkInTime: new FormControl('', [Validators.required]),
      driverName: new FormControl('', [Validators.required]),
      driverMobile: new FormControl('', [Validators.required]),
      imei: new FormControl('', [Validators.required]),
      checkInDate: new FormControl(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'), [Validators.required]),
      startingKM: new FormControl('', [Validators.required])
    });
  }
  public checkInCheckError = (controlName: string, errorName: string) => {
    return this.checkInForm.controls[controlName].hasError(errorName);
  }
  checkOutFormLoad() {
    this.checkOutForm = new FormGroup({
      vehRegNo: new FormControl('', [Validators.required]),
      checkOutTime: new FormControl('', [Validators.required]),
      driverName: new FormControl('', [Validators.required]),
      driverMobile: new FormControl('', [Validators.required]),
      imei: new FormControl('', [Validators.required]),
      checkOutDate: new FormControl(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'), [Validators.required]),
      closingKM: new FormControl('', [Validators.required]),
      startingKM: new FormControl('', [Validators.required])
    });
  }
  public checkOutCheckError = (controlName: string, errorName: string) => {
    return this.checkOutForm.controls[controlName].hasError(errorName);
  }

  openVehCheckInModel() {
    this.vehicleCheckInOutList();
    // this.checkInForm.controls['checkInDate'].disable();
    let d = new Date(),
      h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
      m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    this.checkInForm.controls['checkInTime'].patchValue(h + ':' + m);
    // this.checkInForm.controls['checkInTime'].disable();
    document.getElementById('openCheckInModalBtn')?.click();
  }
  closeCheckIn() {
    this.checkInFormSubmitted = false;
    this.checkInForm.reset();
    this.selVehCapacity = 0;
    this.selVehType = '';
    this.selDriverID = '';
    this.resetForm('checkInForm');
  }
  public selDriverID: string = '';
  checkInFormSubmit() {
    this.checkInFormSubmitted = true;
    if (this.checkInForm.valid) {
      this.isVehicleStatusChanged = false;
      let obj = {
        "orgID": this.orgID,
        "vehRegNo": this.checkInForm.value.vehRegNo,
        "type": "in",
        "time": this.checkInForm.value.checkInTime,
        "driverName": this.selectedDriver[0]['name'],
        "startKM": this.checkInForm.value.startingKM,
        "date": new Date(this.checkInForm.value.checkInDate).getTime(),
        "driverMobile": this.checkInForm.value.driverMobile,
        "imei": this.checkInForm.value.imei,
        "vehInfo": {
          "capacity": this.selVehCapacity,
          "vehType": this.selVehType
        },
        "driverID": this.selectedDriver[0]['driverID'],
        "branch": this.branchChoosen,
      }
      this.api.transportManagerCheckIn(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.checkInFormSubmitted = false;
          // this.getVehicleList();
          this.vehicleCheckInOutList();
          this.checkInForm.reset();
          this.resetForm('checkInForm');
          this.swal.swalFunction('success', res.status, res.message, 5000);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
        this.isVehicleStatusChanged = true;
      }).catch((err) => {
        this.isVehicleStatusChanged = true;
        console.log(err);
      });
    }
  }


  openVehCheckOutModel() {
    this.vehicleCheckInOutList();
    // this.checkOutForm.controls['checkOutDate'].disable();
    let d = new Date(),
      h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
      m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    this.checkOutForm.controls['checkOutTime'].patchValue(h + ':' + m);
    // this.checkOutForm.controls['checkOutTime'].disable();
    document.getElementById('openCheckOutModalBtn')?.click();
  }
  closeCheckOut() {
    this.checkOutFormSubmitted = false;
    this.showCloseKmError = false;
    this.checkOutForm.reset();
    this.resetForm('checkOutForm');
  }
  public vehCheckInDate: string = '';
  public showCloseKmError: boolean = false;
  checkOutFormSubmit() {
    this.checkOutFormSubmitted = true;
    if (this.checkOutForm.valid && !this.showCloseKmError) {
      this.isVehicleStatusChanged = false;
      let obj = {
        "vehRegNo": this.checkOutForm.value.vehRegNo,
        "type": "out",
        "time": this.checkOutForm.value.checkOutTime,
        "endKM": this.checkOutForm.value.closingKM,
        "date": new Date(this.checkOutForm.value.checkOutDate).getTime(),
        "checkInID": this.selectedCheckOutVeh[0]['checkInID'],
      }
      this.api.transportManagerCheckOut(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.checkOutFormSubmitted = false;
          // this.getVehicleList();
          this.vehicleCheckInOutList();
          this.checkOutForm.reset();
          this.resetForm('checkOutForm');
          this.swal.swalFunction('success', res.status, res.message, 5000);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
        this.isVehicleStatusChanged = true;
      }).catch((err) => {
        this.isVehicleStatusChanged = true;
        console.log(err);
      });
    }
  }
  public selectedCheckOutVeh: any = [];
  setDatasBasedOnVehicle(vehicle, form) {
    if (form == 'checkInForm') {
      let vehArr = this.vehicleListArr.filter(e => e.vehRegNo == vehicle);
      if (vehArr && vehArr.length > 0) {
        this.checkInForm.controls['imei'].patchValue(vehArr[0].imei);
        this.vendorID = vehArr[0].vendorID;
        this.getDriverList(vehArr[0].driverID, form);
        this.selVehCapacity = vehArr[0].capacity;
        this.selVehType = vehArr[0].model;
      } else {
        this.availableDrivers = [];
        this.checkInForm.controls['imei'].patchValue('');
        this.checkInForm.controls['driverName'].patchValue('');
        this.checkInForm.controls['driverMobile'].patchValue('');
        this.selVehCapacity = 0;
        this.selVehType = '';
        this.selDriverID = '';
      }
    } else {
      let vehArr = this.checkInVehicles.filter(e => e['vehRegNo'] == vehicle);
      if (vehArr && vehArr.length > 0) {
        this.selectedCheckOutVeh = vehArr;
        // this.getDriverList(vehArr[0]['driverID'],form);
        this.endKmValidation();
        this.vehCheckInDate = vehArr[0]['checkInDate'];
        this.checkOutForm.controls['driverName'].patchValue(vehArr[0]['driverInfo']['name']);
        this.checkOutForm.controls['driverMobile'].patchValue(vehArr[0]['driverInfo']['mobile']);
        this.checkOutForm.controls['imei'].patchValue(vehArr[0]['imei']);
        this.checkOutForm.controls['startingKM'].patchValue(vehArr[0]['checkIn']['startKM']);
        this.checkOutForm.controls['closingKM'].patchValue('');
        this.showCloseKmError = false;
      } else {
        this.selectedCheckOutVeh = [];
        this.availableDrivers = [];
        this.checkOutForm.controls['imei'].patchValue('');
        this.checkOutForm.controls['driverName'].patchValue('');
        this.checkOutForm.controls['driverMobile'].patchValue('');
        this.checkOutForm.controls['startingKM'].patchValue('');
        this.checkOutForm.controls['closingKM'].patchValue('');
        this.showCloseKmError = false;
      }
    }
  }
  endKmValidation() {
    if (this.checkOutForm.value.closingKM == null || this.checkOutForm.value.closingKM == 0
      || this.checkOutForm.value.closingKM == '') {
      this.showCloseKmError = false;
    } else {
      if (this.checkOutForm.value.startingKM <= this.checkOutForm.value.closingKM) {
        this.showCloseKmError = false;
      } else {
        this.showCloseKmError = true;
      }
    }
  }
  public availableDrivers: any = [];
  public selectedDriver: any = [];
  getDriverList(id, form) {
    const driverObj = {
      orgID: this.orgID,
      vendorID: this.vendorID,
      // branch:this.branchChoosen
    };

    this.api.transportManagerDriverList(driverObj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res && res['data'] && res['data'].length > 0 && res['status'] && res['status'] == 'success') {
          this.availableDrivers = res['data'];
          let driverArr = res['data'].filter(e => e.driverID == id);
          this.selectedDriver = driverArr;
          if (driverArr && driverArr.length > 0) {
            if (form == 'checkInForm') {
              this.checkInForm.controls['driverName'].patchValue(driverArr[0].driverID ? driverArr[0].name : '');
              this.checkInForm.controls['driverMobile'].patchValue(driverArr[0].mobile ? driverArr[0].mobile : '');
            } else {
              this.checkOutForm.controls['driverName'].patchValue(driverArr[0].driverID ? driverArr[0].name : '');
              this.checkOutForm.controls['driverMobile'].patchValue(driverArr[0].mobile ? driverArr[0].mobile : '');
            }
          } else {
            if (form == 'checkInForm') {
              this.checkInForm.controls['driverName'].patchValue('');
              this.checkInForm.controls['driverMobile'].patchValue('');
            } else {
              this.checkOutForm.controls['driverName'].patchValue('');
              this.checkOutForm.controls['driverMobile'].patchValue('');
            }
          }
        } else {
          this.availableDrivers = [];
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  setDriverMobile(id, form) {
    if (id != '') {
      let arr = this.availableDrivers.filter(e => e.driverID == id);
      this.selectedDriver = arr;
      this.selDriverID = arr[0].driverID;
      if (form == 'checkInForm') {
        this.checkInForm.controls['driverMobile'].patchValue(arr[0]['mobile']);
      } else {
        this.checkOutForm.controls['driverMobile'].patchValue(arr[0]['mobile']);
      }
    } else {
      this.selectedDriver = [];
      this.checkInForm.controls['driverMobile'].patchValue('');
      if (form == 'checkInForm') {
        this.checkInForm.controls['driverMobile'].patchValue('');
      } else {
        this.checkOutForm.controls['driverMobile'].patchValue('');
      }
      this.selDriverID = '';
    }
  }
  resetForm(form) {
    if (form == 'checkInForm') {
      this.checkInForm.controls['vehRegNo'].patchValue('');
      this.checkInForm.controls['driverName'].patchValue('');
      this.checkInForm.controls['checkInDate'].patchValue(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'));
      let d = new Date(),
        h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
        m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
      this.checkInForm.controls['checkInTime'].patchValue(h + ':' + m);
      this.selVehCapacity = 0;
      this.selVehType = '';
      this.selDriverID = '';
    } else {
      this.checkOutForm.controls['vehRegNo'].patchValue('');
      this.checkOutForm.controls['driverName'].patchValue('');
      this.checkOutForm.controls['checkOutDate'].patchValue(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'));
      let d = new Date(),
        h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
        m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
      this.checkOutForm.controls['checkOutTime'].patchValue(h + ':' + m);
    }

  }
  public overAllCheckedVehicle: any = [];
  vehicleCheckInOutList() {
    const obj = {
      "branch": this.branchChoosen,
      "type": ["out", "in"],
    };
    this.api.transportManagerCheckInOutList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.overAllCheckedVehicle = res['data'];
          this.checkInVehicles = res.data.filter(e => e.type == 'in');
          this.vehiclesCheckedList = res.data.filter(e => e.type == 'in' && !e.routeAssign);
          this.checkOutVehicles = res.data.filter(e => e.type == 'out');
        } else {
          this.overAllCheckedVehicle = [];
          this.checkInVehicles = [];
          this.vehiclesCheckedList = [];
          this.checkOutVehicles = [];
        }
        this.getVehicleList();
      } else {
        this.overAllCheckedVehicle = [];
        this.checkInVehicles = [];
        this.vehiclesCheckedList = [];
        this.checkOutVehicles = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  removeDuplicates(arr, name) {
    let x = [];
    const unique = arr.filter(element => {
      const isDuplicate = x.includes(element[name]);

      if (!isDuplicate) {
        x.push(element[name]);

        return true;
      } else {
        return false;
      }
    });
    return unique;
  }

  //For Upload
  public showUploadForm: boolean = false;
  public uploadForm: FormGroup;
  public uploadFormSubmitted: boolean = false;
  public uploadFileName: any = '';
  public responseMessage: string = '';
  public isExcelInvalid: boolean = false;
  public fileUploadedPercent: string = '';
  public fileUploadedPercentStr: string = '';
  public isFileUploading: boolean = false;
  public selFile: string = '';
  public fileNametimeout: any;
  public clickedDay: string = 'Tomorrow';
  public selectedTimestamp: number = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
  public selDate: string = this.com.timestampToDate(new Date().getTime(), 'YMD', '-');
  selectActiveDay(day) {
    this.isFileUploading = false;
    this.isExcelInvalid = false;
    this.selFile = '';
    this.uploadFileName = '';
    this.responseMessage = '';
    this.fileUploadedPercent = '';
    this.fileUploadedPercentStr = '';
    clearTimeout(this.fileNametimeout);
    if (day == 'Today') {
      this.clickedDay = 'Today';
      this.selDate = this.com.timestampToDate(new Date().getTime(), 'YMD', '-');
      this.selectedTimestamp = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
      // this.uploadForm.controls['tripDate'].patchValue(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'));
      // this.uploadForm.controls['tripDate'].patchValue(new Date(this.uploadForm.value.tripDate).getTime())
    } else if (day == 'Tomorrow') {
      let currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      let day = currentDate.getDate();
      let month: any = currentDate.getMonth() + 1;
      month = String(month).length == 1 ? '0' + String(month) : month;
      let year = currentDate.getFullYear();
      let tmrw = year + '-' + month + '-' + day;
      // this.uploadForm.controls['tripDate'].patchValue(this.com.timestampToDate(new Date(tmrw).getTime(), 'YMD', '-'));
      this.selDate = tmrw;
      // this.selectedTimestamp = new Date(tmrw).getTime();
      this.clickedDay = 'Tomorrow';
    } else {
      this.selDate = this.uploadForm.value.tripDate;
      // this.selectedTimestamp = new Date(this.uploadForm.value.tripDate).getTime();
      this.clickedDay = 'Others';
    }
    // need to uncommand
    this.getRosterfileName();
  }
  public datePickerMode: any = 'single';
  async routeDaysCtrl(e: any) {
    this.dateLoader = false;
    this.alreadyUpload ='';
    const selectedMode = e.value
    // this.uploadForm.controls.files.setValue('');
    this.uploadForm.patchValue({
      files: ''
    })
    this.maxDayserr = false;
    this.isExcelInvalid = false;
    if (['range', 'multiple'].includes(selectedMode)) {
      this.fileUploadedPercent = '';
      this.selFile = '';
      this.uploadFileName = '';
      this.responseMessage = '';
      this.fileUploadedPercent = '';
      this.fileUploadedPercentStr = '';
      this.datePickerMode = selectedMode;
    } else {
      this.datePickerMode = 'single';
      let parsedDate = new Date(this.setTodayDate);
      parsedDate.setHours(0, 0, 0, 0);
      this.findFileNameByDate(parsedDate.getTime())
    }
     
    this.getDatesInput = this.setTodayDate;
    this.uploadForm.value.tripDate = [this.setTodayDate];
    //(getUploadedType && getUploadedType=='range') ? 'range':( getUploadedType=='multiple' ? 'multiple' : '')
    await this.com.sleep(10);
    this.dateLoader = true;
  }

  getFileNameWithTimeout() {
    let obj = {
      tripDate: this.selectedTimestamp,
      branchID: this.clickedBranch
    }
    this.api.transportManagerExcelFileNameHl(obj).then((res: any) => {
      if (res && res.status == 'success' && res.data && res.data.length > 0 && res.data[res.data.length - 1]['progress'] && res.data[res.data.length - 1]['progress'] == 'success') {
        if (res.data[res.data.length - 1]['fileName']) {
          // this.selFile='';
          this.uploadFileName = res.data[res.data.length - 1]['fileName'].substring(6);
        } else {
          this.uploadFileName = '';
        }
        if (res.data[res.data.length - 1]['percentage']) {
          this.fileUploadedPercent = String(res.data[res.data.length - 1]['percentage']);
          this.fileUploadedPercentStr = res.data[res.data.length - 1]['percentage'] + '%';
          if (this.fileUploadedPercent != '100') {
            this.fileNametimeout = setTimeout(() => this.getFileNameWithTimeout(), 10000);
          } else {
            clearTimeout(this.fileNametimeout);
          }
        } else {
          this.fileUploadedPercent = '';
          this.fileUploadedPercentStr = '';
          clearTimeout(this.fileNametimeout);
        }
        if (res.data[res.data.length - 1].message) {
          this.responseMessage = res.data[res.data.length - 1].message;
        } else {
          this.responseMessage = '';
        }
      } else {
        this.uploadFileName = '';
        this.responseMessage = '';
        this.fileUploadedPercent = '';
        this.fileUploadedPercentStr = '';
        clearTimeout(this.fileNametimeout);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  uploadExcelFile(e: any) {
    console.log("check>>>>>>",e)
    this.isFileUploading = false;
    this.selFile = '';
    this.fileUploadedPercent = '';
    this.fileUploadedPercentStr = '';
    this.isExcelInvalid = false;
    if (e.target.value != "") {
      this.selFile = e.target.files[0].name;
      this.uploadFileName = '';
      this.responseMessage = '';
    }
  }
  openFileUpload() {
    // document.getElementById('files')?.click();

    // if (this.uploadFileName == '') {
      document.getElementById('files')?.click();
    // }
  }

  uploadFormLoad() {
    this.uploadForm = new FormGroup({
      datePeriod: new FormControl('single'),
      tripDate: new FormControl([this.setTodayDate], [Validators.required]),
      branch: new FormControl(this.selBranchID ? this.selBranchID : '', [Validators.required]),
      files: new FormControl('', [Validators.required]),
    });
    this.getDatesInput = this.com.timestampToDate(new Date(this.todayDate), 'DMY');
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.uploadForm.controls[controlName].hasError(errorName);
  }

  deleteUploadFile() {
    this.uploadForm.value.files = '';
  }

  getDaysArray(start, end) {
    let dateArr = [];
    for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
      dateArr.push(new Date(dt).getTime());
    }
    return dateArr;
  };
  public getDatesInput: any = '';
  public maxDayserr: boolean = false;
  getSelectedDates(e: any) {
    this.getDatesInput = e.dateStr;
    if (e.dateStr.includes("to")) {
      const [startDate, endDate] = e.dateStr.split(' to ');
      let getLoopDate = this.getDaysArray(new Date(new Date(startDate).setHours(0, 0, 0, 0)).getTime(), new Date(new Date(endDate).setHours(0, 0, 0, 0)).getTime());
      if (getLoopDate.length > 30) {
        return this.maxDayserr = true;
      } else {
        this.maxDayserr = false;
      }      
      if (this.maxDayserr) return
      this.uploadForm.controls['tripDate'].patchValue(getLoopDate);
    } else {
      let dateValue = e.dateStr.split(',').map((date) => {
        return new Date(new Date(date.trim()).setHours(0, 0, 0, 0)).getTime();
      })
      if (dateValue.length > 30) {
        return this.maxDayserr = true;
      } else {
        this.maxDayserr = false;
      }
      if (this.maxDayserr) return
      if (this.datePickerMode == 'single') {
        this.findFileNameByDate(dateValue[0])
      }
      this.uploadForm.controls['tripDate'].patchValue(dateValue);
    }
  }

  getRosterfileName() {
    let obj = {
      tripDate: this.selectedTimestamp,
      branchID: this.clickedBranch
    }
    this.api.transportManagerExcelFileNameHl(obj).then((res: any) => {
      console.log("statusssssssss",res)
      this.alreadyUpload=res.data; 
      console.log("this.alreadyUpload",this.alreadyUpload)
      if (res && res.status == 'success' && res.data && res.data.length > 0 && res.data[res.data.length - 1]['progress'] && res.data[res.data.length - 1]['progress'] == 'success') {
        if (res.data[res.data.length - 1]['fileName']) {
          // this.selFile='';
          this.uploadFileName = res.data[res.data.length - 1]['fileName'].substring(6);
        } else {
          this.uploadFileName = '';
        }
        if (res.data[res.data.length - 1]['percentage']) {
          this.fileUploadedPercent = String(res.data[res.data.length - 1]['percentage']);
          this.fileUploadedPercentStr = res.data[res.data.length - 1]['percentage'] + '%';
          if (this.fileUploadedPercent != '100') {
            this.fileNametimeout = setTimeout(() => this.getFileNameWithTimeout(), 10000);
          } else {
            clearTimeout(this.fileNametimeout);
          }
        } else {
          this.fileUploadedPercent = '';
          this.fileUploadedPercentStr = '';
          clearTimeout(this.fileNametimeout);
        }
        if (res.data[res.data.length - 1].message) {
          this.responseMessage = res.data[res.data.length - 1].message;
        } else {
          this.responseMessage = '';
        }
      } else {
        this.uploadFileName = '';
        this.responseMessage = '';
        this.fileUploadedPercent = '';
        this.fileUploadedPercentStr = '';
        clearTimeout(this.fileNametimeout);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  openUploadModel() {
    this.showUploadForm = true;
    this.isExcelUploaded = false;
    let currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    let day = currentDate.getDate();
    let month: any = currentDate.getMonth() + 1;
    month = String(month).length == 1 ? '0' + String(month) : month;
    let year = currentDate.getFullYear();
    let tmrw = year + '-' + month + '-' + day;
    // this.uploadForm.controls['tripDate'].patchValue(this.com.timestampToDate(new Date(tmrw).getTime(), 'YMD', '-'));
    this.uploadForm.patchValue({
      tripDate: [this.setTodayDate],
    });
    if (this.branchChoosen.length == 1) {
      this.clickedBranch = this.branchChoosen[0];
      this.uploadForm.controls['branch'].patchValue(this.branchChoosen[0]);
      this.selectActiveDay('Today');
    } else {
      this.uploadForm.controls['branch'].patchValue('');
    }
    this.maxDayserr = false;
    document.getElementById('openUploadModalBtn')?.click();
  }
  findFileNameByDate(value) {
    this.selectedTimestamp = value;
    let today = this.com.timestampToDate(new Date().getTime(), 'YMD', '-');
    let currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    let day = currentDate.getDate();
    let month: any = currentDate.getMonth() + 1;
    month = String(month).length == 1 ? '0' + String(month) : month;
    let year = currentDate.getFullYear();
    let tmrw = year + '-' + month + '-' + day;
    // if (value == today) {
    //   this.selectActiveDay('Today');
    // } else if (value == tmrw) {
    //   this.selectActiveDay('Tomorrow');
    // } else {
    //   this.selectActiveDay('Others');
    // }
    this.isFileUploading = false;
    this.isExcelInvalid = false;
    this.selFile = '';
    this.uploadFileName = '';
    this.responseMessage = '';
    this.fileUploadedPercent = '';
    this.fileUploadedPercentStr = '';
    clearTimeout(this.fileNametimeout);
    if (value != '' && this.uploadForm.value.branch != '') {
      this.clickedBranch = this.uploadForm.value.branch;
      this.getRosterfileName();
    }
  }
  findClickedBranch(value) {
    this.isFileUploading = false;
    this.isExcelInvalid = false;
    this.selFile = '';
    this.uploadFileName = '';
    this.responseMessage = '';
    this.fileUploadedPercent = '';
    this.fileUploadedPercentStr = '';
    clearTimeout(this.fileNametimeout);
    this.uploadForm.controls['files'].patchValue('');
    if (value != '') {
      this.clickedBranch = value;
      //this.getRosterfileName();
      this.fileNametimeout = setTimeout(() => this.getFileNameWithTimeout(), 500);
    } else {
      this.clickedBranch = '';
    }
  }
  previewModalOpen() {
    console.log("hitttt>>",this.uploadForm.value)
    this.uploadFormSubmitted = true;
    if (typeof this.uploadForm.value.tripDate[0] == 'object') {
      let convertedTripDate = this.uploadForm.value.tripDate.map(date => {
        let parsedDate = new Date(date);
        parsedDate.setHours(0, 0, 0, 0);
        // Parse the date string
        return isNaN(parsedDate.getTime()) ? null : parsedDate.getTime(); // Convert to timestamp or return null if invalid
      });
      this.uploadForm.controls['tripDate'].patchValue(convertedTripDate);
    }
    if(this.uploadForm.valid && this.uploadFormSubmitted && !this.maxDayserr && this.alreadyUpload.length > 0){
      console.log("reuploaddd>>>>",this.uploadForm.value)
    }
  else if (this.uploadForm.valid && this.uploadFormSubmitted && !this.maxDayserr && (!this.alreadyUpload || this.alreadyUpload?.length == 0)) {
      console.log("actuall>>>>",this.uploadForm.value)
      document.getElementById('openPreviewModal')?.click();
    }
  }
  closePreviewModal() {
    // this.isFileUploading=false;
  }
  submitEmployeeUpload() {
    this.isFileUploading = true;
    // const dateObject = new Date(dateValue);
    //   this.milliseconds = dateObject.getTime();

    // const currentMilliseconds = new Date(this.uploadForm.value.tripDate);
    // currentMilliseconds.setHours(0, 0, 0, 0);
    // this.uploadForm.controls.tripDate.setValue(currentMilliseconds.getTime());

    let obj = {
      "tripDate":this.uploadForm.value.tripDate,
      "branch": this.uploadForm.value.branch,
      "rosterType": "dynamic"
    };


    //  let cleanedObj = this.parseValues(obj);

    let url = 'organization/route/createRost';
    if (this.uploadForm.valid) {
      this.disableUpload = true;
      this.isExcelUploaded = false;
      // setTimeout(()=>{
      //  this.getRosterfileName();
      // },2000)
      this.fileUploadedPercent = '5';
      this.fileUploadedPercentStr = '5%';
      this.responseMessage = 'Data validating!';
      this.fileNametimeout = setTimeout(() => this.getFileNameWithTimeout(), 2000);
      this.api.xlsxFileUpload(obj, url, 'files', (res: any) => {
        let response = res['responseJSON'];
        this.checkInFormSubmitted = false;
        if (this.isFileUploading) {
          if (response && response.percentage == 100 && response.invalidBranchCount <= 0 &&
            response.repeatIDCount <= 0 && response.validationFailsCount <= 0) {
            clearTimeout(this.fileNametimeout);
            this.isExcelInvalid = false;
            // this.isExcelUploaded=true;
            // document.getElementById('closeUploadBtn')?.click();
            this.resetUploadForm();
            this.findFileNameByDate(this.uploadForm.value.tripDate);
            this.getRosterfileName();
            this.swal.swalFunction('success', 'success', response.message, 5000);
          } else {
            clearTimeout(this.fileNametimeout);
            this.disableUpload = false;
            this.errDataCount = 0;
            if (response.status == 'failure' && response.message == 'Roster file already uploaded.') {
              this.swal.swalFunction('error', 'failure', response.message, 5000);
            } else if (response.status == 'failure' && response.message?.dispatch == 'Roster file uploaded for the following dates.') {
              let message = response.message?.dispatch + " " + response.message?.date;
              this.swal.swalFunction('error', 'failure', message, 5000);
            } else if (response.status == 'failure' && response.message == 'Incorrect date we accept only present or future date.') {
              this.getRosterfileName();
              this.swal.swalFunction('error', 'failure', response.message, 5000);
            } else if (response.status == 'failure' && response.percentage == 15) {
              this.getRosterfileName();
              this.errDataCount = response['data'].length;
              this.swal.swalFunction('warning', 'failure', response.message, 5000);
              this.errorExcelDownload('Header validation', response['data']);
            } else if (response.status == 'failure' && response.percentage == 35) {
              this.getRosterfileName();
              this.swal.swalFunction('warning', 'failure', response.message, 5000);
              this.errDataCount = response.validationFailsCount;
              this.errorExcelDownload('Data validation', response['validationFails']);
            } else if (response.status == 'failure' && response.percentage == 45) {
              this.getRosterfileName();
              if (response.repeatIDCount > 0) {
                this.errDataCount = response.repeatIDCount;
                this.errorExcelDownload('Repeat ID', response['repeatID']);
              } else if (response.invalidBranchCount > 0) {
                this.errDataCount = response.invalidBranchCount;
                this.errorExcelDownload('Invalid branch', response['invalidBranch']);
              }
              this.swal.swalFunction('warning', 'failure', response.message, 5000);
            } else {
              this.getRosterfileName();
              // this.errDataCount=response.invalidBranchCount;
              // this.errorExcelDownload('Invalid branch',response['invalidBranch']);
              this.swal.swalFunction('error', 'failure', 'Upload Failed!', 5000);
            }
            this.isExcelInvalid = true;
          }
        }
      })
    }
    document.getElementById('closePreview')?.click();
  }

  parseValues = (inputObj) => {
    const cleanedObj = {};
    for (const key in inputObj) {
      if (inputObj.hasOwnProperty(key)) {
        // Remove the escaped quotes
        cleanedObj[key] = inputObj[key].replace(/^"|"$/g, '');
      }
    }
    return cleanedObj;
  };


  public errDataCount: number = 0;
  public errDataRepeatIdCount: number = 0;
  public getRow: any = '';
  public getNameOfErr: any = '';
  errorExcelDownload(str, validationObj) {
    let resExcelData = {};
    let res = {}
    let errorData = [];
    let errCount = 0;
    let rowCount = 2;
    let customizedData = [];
    let endCell = 'F';
    let tripDate = this.selDate;
    let titleRow = {
      value: ['Roster File Upload Errors Report'],
      font: {
        name: 'Corbel', family: 4, size: 16, bold: true,
        color: { argb: 'FFFFFFFF' },
      },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      alignment: {
        cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '966462AF' },
        bgColor: { argb: 'FFF' }
      },
    }
    customizedData.push(titleRow);

    rowCount += 2;//4
    let subtitleRow = {
      value: [
        "Trip Date          : " + tripDate + "\n"
      ],
      font: { name: 'Corbel', family: 4, size: 12, },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
    }
    customizedData.push(subtitleRow);

    if (validationObj && Object.keys(validationObj).length > 0) {
      rowCount += 2;
      let errCountRow = {
        // value: [
        //   "Validation Fail Count          : " + this.errDataCount + "\n"
        // ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }
      if (str == 'Data validation') {
        errCountRow['value'] = [
          "Validation Fail Count          : " + this.errDataCount + "\n"
        ]
      } else if (str == 'Header validation') {
        errCountRow['value'] = [
          "Wrong Header Count            : " + this.errDataCount + "\n"
        ]
      } else if (str == 'Repeat ID') {
        errCountRow['value'] = [
          "Repeat ID Count          : " + this.errDataCount + "\n"
        ]
      } else if (str == 'Invalid branch') {
        errCountRow['value'] = [
          "Invalid branch Count          : " + this.errDataCount + "\n"
        ]
      }
      rowCount = rowCount + 1;
      let errHeaderRow =
      {
        value: ['S No', 'Row No', 'Error'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        mergeCells: `C${rowCount}:F${rowCount}`,
      }
      if (str == 'Repeat ID') {
        errHeaderRow['value'] = ['S No', 'Employee ID', 'Repeated Rows'];
      } else if (str == 'Invalid branch') {
        errHeaderRow['value'] = ['S No', 'Row', 'Employee ID', 'Branch'];
        errHeaderRow['mergeCells'] = `D${rowCount}:F${rowCount}`;
      }

      if (str == 'Data validation') {
        if (validationObj && Object.keys(validationObj).length > 0) {
          let rows = Object.keys(validationObj);
          for (let i = 0; i < rows.length; i++) {
            let errorArr = validationObj[rows[i]];
            let errors = '';
            for (let j = 0; j < errorArr.length; j++) {
              if (j == 0) {
                errors = validationObj[rows[i]][j];
              } else {
                errors = errors + ', ' + validationObj[rows[i]][j];
              }
            }
            errCount += 1;
            try {
              rowCount = rowCount + 1;
              res = {
                value: [
                  errCount,
                  // tripDate,
                  rows[i],
                  errors
                ],
                mergeCells: `C${rowCount}:F${rowCount}`,
              }
              errorData.push(res);
            } catch (err) { console.log(err) }
          }
        }
      } else if (str == 'Header validation') {
        if (validationObj && Object.keys(validationObj).length > 0) {
          let rows = Object.keys(validationObj);
          for (let i = 0; i < rows.length; i++) {
            let error = validationObj[rows[i]];
            errCount += 1;
            try {
              rowCount = rowCount + 1;
              res = {
                value: [
                  errCount,
                  // tripDate,
                  1,
                  error
                ],
                mergeCells: `C${rowCount}:F${rowCount}`,
              }
              errorData.push(res);
            } catch (err) { console.log(err) }
          }
        }

      } else if (str == 'Repeat ID') {
        if (validationObj && Object.keys(validationObj).length > 0) {
          let rows = Object.keys(validationObj);
          for (let i = 0; i < rows.length; i++) {
            let errorArr = validationObj[rows[i]];
            let errors = '';
            for (let j = 0; j < errorArr.length; j++) {
              if (j == 0) {
                errors = 'Row : ' + validationObj[rows[i]][j]['row'];
              } else {
                errors = errors + ', ' + 'Row : ' + validationObj[rows[i]][j]['row'];
              }
            }
            errCount += 1;
            try {
              rowCount = rowCount + 1;
              res = {
                value: [
                  errCount,
                  // tripDate,
                  rows[i].toUpperCase(),
                  errors
                ],
                mergeCells: `C${rowCount}:F${rowCount}`,
              }
              errorData.push(res);
            } catch (err) { console.log(err) }
          }
        }
      } else if (str == 'Invalid branch') {
        if (validationObj && Object.keys(validationObj).length > 0) {
          for (let i = 0; i < validationObj.length; i++) {
            errCount += 1;
            try {
              rowCount = rowCount + 1;
              res = {
                value: [
                  errCount,
                  validationObj[i].row,
                  validationObj[i].empRefID,
                  validationObj[i].location,
                ],
                mergeCells: `D${rowCount}:F${rowCount}`,
              }
              errorData.push(res);
            } catch (err) { console.log(err) }
          }
        }
      }

      // errCountRow['value'] = ["Error Counts          : " + this.errDataCount + "\n"];

      customizedData.push(errCountRow, errHeaderRow, ...errorData);


      let excelSheetName = 'Roster-Upload-Errors-Report';

      if (resExcelData[excelSheetName] == undefined) { resExcelData[excelSheetName] = {}; }


      resExcelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 1, width: 15 }, { colNo: 2, width: 15 }, { colNo: 3, width: 15 }, { colNo: 4, width: 30 }, { colNo: 5, width: 30 }, { colNo: 6, width: 30 }]
        }
      };

    }
    if (validationObj && Object.keys(validationObj).length > 0) {
      this.excel.generateExcel(resExcelData, 'Roster-File-Upload-Errors-Report.xlsx');
    }
  }
  getDataWhenClosepopup() {
    this.resetUploadForm();
    this.isExcelUploaded = true;
  }
  resetUploadForm() {
    this.uploadFormSubmitted = false;
    this.isExcelInvalid = false;
    this.uploadFileName = '';
    this.responseMessage = '';
    this.selFile = '';
    this.isFileUploading = false;
    this.disableUpload = false;
    this.fileUploadedPercent = '';
    this.fileUploadedPercentStr = '';
    this.disableAllInputs = false;
    this.maxDayserr = false;
    this.uploadForm.controls['files'].enable();
    this.uploadForm.reset();
    this.uploadForm.patchValue({
      datePeriod: 'single',
      tripDate: [this.setTodayDate],
      branch: this.selBranchID ? this.selBranchID : '',
      files: '',
    });
    this.routeDaysCtrl({ value: this.uploadForm.value.datePeriod });
    this.getDatesInput = this.com.timestampToDate(new Date(this.setTodayDate), 'DMY');
  }

 
  public uploadCheckError = (controlName: string, errorName: string) => {
    return this.uploadForm.controls[controlName].hasError(errorName);
  }
  convertDateFormat(x) {
    let arr = x.split('-');//01-11-2023
    let monArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let month = monArr[Number(arr[1]) - 1];
    let reqFormat = arr[0] + '-' + month + '-' + arr[2];
    return reqFormat;
  }
  downloadExcelTemplate() {
    let dates = [];
    let tempExlData = {};
    let customizedData = [];
    let loopDate = new Date(new Date().getTime());
    let headerRow =
    // value : this.getExcelHeaders,
    {
      value: ['Employee Id', 'Emp Name', 'Gender', 'Grade', 'Designation', 'Address1', 'Address2', 'Area', 'Landmark', 'Route Description', 'Mobile', 'Telephone', 'Location', 'Location Address (Lat, Lng)', 'Client', 'Team', this.convertDateFormat(this.com.timestampToDate(new Date().getTime(), 'DMY', '-')), 'Shift Duration', 'Employee Email Id', 'Supervisor Email Id', 'Employee Status', 'Leave Status', 'Transport', 'Pickup & Drop Point', 'L1', 'L2', 'L3', 'L4', 'Trip Type'],
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'C0C0C0' },
        bgColor: { argb: 'FFFFFF00' }
      },
      headerAlign: {
        cell: ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1', 'Z1', 'AA1', 'AB1', 'AC1'],
        value: { vertical: 'middle', horizontal: 'center' },
      },
      font: { bold: true },
      border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    }
    customizedData.push(headerRow);

    // let valueRow = {
    //   value: [1,'XYZ123','XXXX Y','XXXXXXXXXX','M/F/T','HH:MM to HH:MM','HH:MM','XYZ ZZZ','XX00YY0000 XYZ XXXXXXXXXX','HH:MM','XYZ ZZZ','XX00YY0000 XYZ XXXXXXXXXX','ABCXYZ','XYZ','HH:MM','HH:MM','11.1112,22.2222','11.1112,22.2222','HH:MM','HH:MM','11.1112,22.2222','11.1112,22.2222','XXX111','Developement','Escort','XXX']
    // }
    // customizedData.push(valueRow);

    let excelSheetName = this.com.pad(loopDate.getDate()) + '-' + this.com.pad(loopDate.getMonth() + 1) + '-' + this.com.pad(loopDate.getFullYear());

    if (dates.length == 1) excelSheetName = 'Roster';
    if (tempExlData[excelSheetName] == undefined) { tempExlData[excelSheetName] = {}; }

    tempExlData[excelSheetName] = {
      customizedData: customizedData,
      data: {
        columWith: [{ colNo: 1, width: 20 }, { colNo: 2, width: 25 }, { colNo: 3, width: 10 }, { colNo: 4, width: 10 }, { colNo: 5, width: 25 }, { colNo: 6, width: 35 }, { colNo: 7, width: 35 }, { colNo: 8, width: 20 }, { colNo: 9, width: 25 }, { colNo: 10, width: 35 }, { colNo: 11, width: 15 }, { colNo: 12, width: 15 }, { colNo: 13, width: 30 }, { colNo: 14, width: 35 }, { colNo: 15, width: 20 }, { colNo: 16, width: 20 }, { colNo: 17, width: 20 }, { colNo: 18, width: 20 }, { colNo: 19, width: 30 }, { colNo: 20, width: 30 }, { colNo: 21, width: 20 }, { colNo: 22, width: 20 }, { colNo: 23, width: 20 }, { colNo: 24, width: 35 }, { colNo: 25, width: 20 }, { colNo: 26, width: 20 }, { colNo: 27, width: 20 }, { colNo: 28, width: 20 }, { colNo: 29, width: 20 }]
      }
    };
    this.excel.generateExcel(tempExlData, 'Roster-Template-' + this.com.timestampToDate(new Date().getTime(), 'DMY', '/') + '.xlsx');

  }
  formatDate(date) {
    var today: any = date;
    var dd: any = today.getDate();
    var mm: any = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd;
    return today;
  }

  //Escort checkin
  public allEscortList: any = [];
  public checkInEscort: any = [];
  public checkOutEscort: any = [];
  public checkedEscortList: any = [];
  public escortCheckInOutID: any = '';
  public escortCheckInFormSubmitted: boolean = false;
  public escortCheckOutFormSubmitted: boolean = false;
  public selEscort: any = [];
  public showEscortCheckInForm: boolean = false;
  public showEscortCheckOutForm: boolean = false;
  getEscortList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      department: "escort",
      // branch :this.branchChoosen
    };

    this.api.transportManagerEscortList(obj).then((res: any) => {
      if (res && res.status == 'success' && res.data && res.data.length > 0) {
        if (this.checkInEscort && this.checkInEscort.length > 0) {
          this.allEscortList = res.data.filter(({ escortID: id1 }) => !this.checkInEscort.some(({ escortID: id2 }) => id2 === id1));
        } else {
          this.allEscortList = res.data;
        }
      } else {
        this.allEscortList = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  escortCheckInFormLoad() {
    this.escortCheckInForm = new FormGroup({
      escortName: new FormControl('', [Validators.required]),
      escortMobile: new FormControl('', [Validators.required]),
      checkInDate: new FormControl(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'), [Validators.required]),
      checkInTime: new FormControl('', [Validators.required]),
    });
  }
  public escortCheckInCheckError = (controlName: string, errorName: string) => {
    return this.escortCheckInForm.controls[controlName].hasError(errorName);
  }
  escortCheckOutFormLoad() {
    this.escortCheckOutForm = new FormGroup({
      escortName: new FormControl('', [Validators.required]),
      escortMobile: new FormControl('', [Validators.required]),
      checkOutDate: new FormControl(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'), [Validators.required]),
      checkOutTime: new FormControl('', [Validators.required]),
    });
  }
  public escortCheckOutCheckError = (controlName: string, errorName: string) => {
    return this.escortCheckOutForm.controls[controlName].hasError(errorName);
  }
  escortChange(value, form) {
    if (form == 'escortCheckInForm') {
      if (value == '') {
        this.escortCheckInForm.controls['escortMobile'].patchValue('');
        this.selEscort = [];
      } else {
        this.selEscort = this.allEscortList.filter(e => e.escortID == value);
        this.escortCheckInForm.controls['escortMobile'].patchValue(this.selEscort[0].mobile);
      }
    } else {
      if (value == '') {
        this.escortCheckOutForm.controls['escortMobile'].patchValue('');
        this.selEscort = [];
      } else {
        this.selEscort = this.checkInEscort.filter(e => e.escortID == value);
        this.escortCheckOutForm.controls['escortMobile'].patchValue(this.selEscort[0].mobile);
      }
    }
  }
  getEscortCheckInOutList() {
    let today = new Date().setHours(0, 0, 0, 0);
    let currentDate = new Date();
    let date = new Date(currentDate);
    date.setDate(date.getDate() - 1);
    let previousDate = date.getTime();
    let yesterday = new Date(previousDate).setHours(0, 0, 0, 0);
    let obj = {
      date: [yesterday, today],
      branchID: this.branchChoosen[0]
    }
    this.api.transportManagerEscortCheckInOutList(obj).then((res: any) => {
      if (res && res.status == 'success' && res.data && res.data.length > 0) {
        this.checkInEscort = res.data.filter(e => e.type == 'in');
        this.checkOutEscort = res.data.filter(e => e.type == 'out');
        this.checkedEscortList = res.data.filter(e => e.type == 'in' && !e.routeAssign);
        // this.escortCheckInOutID=res['data']['checkInOutID'];
      } else {
        this.checkInEscort = [];
        this.checkOutEscort = [];
        this.checkedEscortList = [];
        this.escortCheckInOutID = '';
      }
      this.getEscortList();
    }).catch((err) => {
      console.log(err);
    });
  }
  openEscortCheckInModel() {
    this.showEscortCheckInForm = true;
    this.getEscortCheckInOutList();
    let d = new Date(),
      h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
      m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    this.escortCheckInForm.controls['checkInTime'].patchValue(h + ':' + m);
    document.getElementById('openEscortCheckinBtn')?.click();
  }
  escortCheckInSubmit() {
    this.escortCheckInFormSubmitted = true;
    if (this.escortCheckInForm.valid) {
      let obj = {
        "name": this.selEscort[0].name,
        "branchID": this.branchChoosen[0],
        "mobile": this.selEscort[0].mobile,
        "date": new Date(this.escortCheckInForm.value.checkInDate).getTime(),
        "time": this.escortCheckInForm.value.checkInTime,
        "escortID": this.selEscort[0].escortID,
        "type": "in"
      }
      this.api.transportManagerEscortCheckIn(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.escortCheckInFormSubmitted = false;
          this.escortCheckInForm.reset();
          this.getEscortCheckInOutList();
          this.resetEscortForm('checkInForm');
          this.swal.swalFunction('success', res.status, res.message, 5000);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  closeEscortCheckIn() {
    this.showEscortCheckInForm = false;
    this.escortCheckInFormSubmitted = false;
    this.escortCheckInForm.reset();
    this.resetEscortForm('checkInForm');
  }
  resetEscortForm(form) {
    if (form == 'checkInForm') {
      this.escortCheckInForm.controls['escortName'].patchValue('');
      this.escortCheckInForm.controls['checkInDate'].patchValue(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'));
      let d = new Date(),
        h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
        m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
      this.escortCheckInForm.controls['checkInTime'].patchValue(h + ':' + m);
    } else {
      this.escortCheckOutForm.controls['escortName'].patchValue('');
      this.escortCheckOutForm.controls['checkOutDate'].patchValue(this.com.timestampToDate(new Date().getTime(), 'YMD', '-'));
      let d = new Date(),
        h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
        m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
      this.escortCheckOutForm.controls['checkOutTime'].patchValue(h + ':' + m);
    }

  }
  openEscortCheckOutModel() {
    this.showEscortCheckOutForm = true;
    this.getEscortCheckInOutList();
    let d = new Date(),
      h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
      m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    this.escortCheckOutForm.controls['checkOutTime'].patchValue(h + ':' + m);
    document.getElementById('openEscortCheckoutBtn')?.click();
  }
  escortCheckOutSubmit() {
    this.escortCheckOutFormSubmitted = true;
    if (this.escortCheckOutForm.valid) {
      let obj = {
        "name": this.selEscort[0].name,
        "branchID": this.branchChoosen[0],
        "mobile": this.selEscort[0].mobile,
        "date": new Date(this.escortCheckOutForm.value.checkOutDate).getTime(),
        "time": this.escortCheckOutForm.value.checkOutTime,
        "escortID": this.selEscort[0].escortID,
        "type": "out",
        "escortCheckInID": this.selEscort[0]['escortCheckInID']
      }
      this.api.transportManagerEscortCheckOut(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.escortCheckOutFormSubmitted = false;
          this.escortCheckOutForm.reset();
          this.getEscortCheckInOutList();
          this.resetEscortForm('checkOutForm');
          this.swal.swalFunction('success', res.status, res.message, 5000);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  closeEscortCheckOut() {
    this.escortCheckOutFormSubmitted = false;
    this.escortCheckOutForm.reset();
    this.showEscortCheckOutForm = false;
    this.resetEscortForm('checkOutForm');
  }

  rosterExcelTemplate() {
    document.getElementById('excelTemplate').click();
  }

  // rosterExcelTemplate(){
  //   let dates = [];
  //   let tempExlData = {};
  //   if(this.uploadForm.value.tripDate && this.uploadForm.value.tripDate.length>0) dates = this.uploadForm.value.tripDate;
  //   else dates = [ new Date().getTime() ]; 

  //     let customizedData = [];
  //     let loopDate = new Date(dates[0]);
  //     let headerRow =
  //     // value : this.getExcelHeaders,
  //     {
  //         value: ['Employee Id','Emp Name','Gender','Mobile','Telephone','Location','Shift','Shift Duration','Employee Email Id','Supervisor Email Id','TripType'],  
  //         font: { bold: true },
  //         border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
  //       }
  //       customizedData.push(headerRow);

  //       let valueRow = {
  //         value: ['TC5-460','Santhos','Male','9952413036','8987842342','Hyderabad','General','9','santhos@gmail.com','selvan@gmail.com','pickup']
  //       }
  //       customizedData.push(valueRow);
  //       let excelSheetName = this.com.pad(loopDate.getDate())+'-'+this.com.pad(loopDate.getMonth()+1)+'-'+this.com.pad(loopDate.getFullYear());

  //       if(dates.length==1) excelSheetName = 'Roster'; 
  //       if (tempExlData[excelSheetName] == undefined) { tempExlData[excelSheetName] = {}; }
  //       tempExlData[excelSheetName] = {
  //         customizedData: customizedData,
  //         data: {
  //           columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 25 }, { colNo: 4, width: 25 }, { colNo: 5, width: 10 }, { colNo: 6, width: 25 }, { colNo: 7, width: 25 }, { colNo: 8, width: 20 }, { colNo: 9, width: 20 },{ colNo: 10, width: 20 },{ colNo:11, width: 25 }]
  //         }
  //       };


  //     this.excel.generateExcel(tempExlData,'Roster-Template-' + this.com.convertTitleCase('single') + new Date().getTime() + '.xlsx');

  // }
}
